import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import UploadDocPopup from "../UploadDocPopup";
import { useLocation, useNavigate } from "react-router-dom";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";
import {
  getDocDeletedStatus,
  getPartCandidateAppTasks,
  getPartnerCandidateApps,
  getPartnerFilterCandidate,
  getUpdateDocSentStatus,
  loadCandidateAppRuningTasks,
  loadPartnerCandidateApps,
  loadPartnerFilterCandidate,
  partnerCandidateDocDelete
} from "../../app/store/partner";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import useDocDownload from "../../app/hooks/useDocDownload";
import { getReqDocuments, loadReqDocuments } from "../../app/store/documents";
import { getAppDocuments, loadAppDocuments } from "../../app/store/candidate";
import { OverlayTrigger, Popover } from "react-bootstrap";

const CANDIDATE_WORKING_HUB_STYLES = {
  pageActions: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "8px 0 10px"
  },
  backButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "8px",
    overflowX: "auto",
    overflowY: "visible",
    backgroundColor: "#ffffff",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
  },
  summaryTable: {
    marginBottom: 0,
    minWidth: "980px",
  },
  table: {
    marginBottom: 0,
    minWidth: "960px",
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px",
    whiteSpace: "nowrap",
    verticalAlign: "top"
  },
  tableCell: {
    verticalAlign: "middle",
    padding: "18px 16px",
    borderTop: "1px solid rgba(241, 245, 249, 1)",
    background: "#ffffff",
    color: "#334155",
    fontSize: "13px"
  },
  idPill: {
    display: "inline-flex",
    alignItems: "center",
    padding: "5px 10px",
    borderRadius: "999px",
    backgroundColor: "#e0f2fe",
    color: "#075985",
    fontSize: "12px",
    fontWeight: 700,
    marginBottom: "8px"
  },
  secondaryPill: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: "999px",
    backgroundColor: "#f1f5f9",
    color: "#475569",
    fontSize: "12px",
    fontWeight: 600
  },
  candidateName: {
    margin: 0,
    color: "#0f172a",
    fontSize: "15px",
    fontWeight: 700,
    textTransform: "uppercase"
  },
  infoText: {
    display: "block",
    color: "#475569",
    fontSize: "13px",
    lineHeight: 1.5
  },
  statusPillBase: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    borderRadius: "999px",
    padding: "6px 10px",
    fontSize: "12px",
    fontWeight: 700,
    border: "1px solid transparent"
  },
  successPill: {
    color: "#166534",
    backgroundColor: "#f0fdf4",
    borderColor: "rgba(187, 247, 208, 1)"
  },
  warningPill: {
    color: "#92400e",
    backgroundColor: "#fffbeb",
    borderColor: "rgba(253, 230, 138, 1)"
  },
  neutralPill: {
    color: "#475569",
    backgroundColor: "#f8fafc",
    borderColor: "rgba(226, 232, 240, 1)"
  },
  card: {
    borderRadius: "8px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  cardHeader: {
    padding: "20px 22px 16px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
    flexWrap: "wrap"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0
  },
  titleIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    border: "1px solid rgba(191, 219, 254, 1)",
    fontSize: "16px",
    flexShrink: 0
  },
  title: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    margin: "0 0 4px"
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#64748b",
    margin: 0
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  cardBody: {
    padding: "18px 22px 22px"
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
    gap: "12px",
    marginBottom: "16px"
  },
  statCard: {
    borderRadius: "8px",
    padding: "13px 14px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 24px rgba(37, 99, 235, 0.06)"
  },
  statLabel: {
    margin: "0 0 6px",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b"
  },
  statValue: {
    margin: 0,
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "12px"
  },
  toolbarText: {
    margin: 0,
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap"
  },
  textButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "7px",
    borderRadius: "8px",
    border: "1px solid rgba(224, 231, 255, 1)",
    background: "#eef2ff",
    color: "#4338ca",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
    textDecoration: "none",
    whiteSpace: "normal",
    lineHeight: 1.2,
    textAlign: "center"
  },
  dangerButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    borderRadius: "8px",
    border: "1px solid rgba(254, 202, 202, 1)",
    background: "#fef2f2",
    color: "#991b1b",
    padding: "7px 10px",
    fontSize: "12px",
    fontWeight: 700,
    marginLeft: "8px"
  },
  emptyState: {
    padding: "32px 20px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "13px",
    backgroundColor: "#ffffff"
  }
};

export default function CandidateWorkingHub() {
  const route = [
    { name: "Contract Management", url: "" },
    { name: "List of Candidates", url: "/PartnerCandidates" },
  ];

  const [candidateObj, setCandidateObj] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [wfTask, setWfTask] = useState(null);
  const [docShowHide, setDocShowHide] = useState(false);
  const [reqDocuments, setReqDocuments] = useState([]);
  const [docType, setDocType] = useState("");
  const [allAppDocs, setAllAppDocs] = useState([]);
  const [appWorkflow, setAppWorkflow] = useState(null);

  const partCandidateAppsSelector = useSelector(getPartnerCandidateApps);
  const partCandidateAppTasksSelector = useSelector(getPartCandidateAppTasks);
  const docSendStatus = useSelector(getUpdateDocSentStatus);
  const partnerFilterCandidateSelector = useSelector(getPartnerFilterCandidate);
  const reqDocumentsSelector = useSelector(getReqDocuments);
  const appDocumentsSelector = useSelector(getAppDocuments);
  const docDeletedStatusSelector = useSelector(getDocDeletedStatus);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Candidate Upload Documents"));
    dispatch(setCurrentRoute(route))
  }, [])

  useEffect(() => {
    const state = location.state;
    if (state) {
      setSelectedItem(state);
      if (state.subcontractor?.fuid && state?.performerid > 0) {
        dispatch(loadPartnerFilterCandidate(state.subcontractor?.fuid, state.performerid));
        dispatch(loadPartnerCandidateApps(state.performerid));
      }
    }
  }, []);

  useEffect(() => {
    if (partnerFilterCandidateSelector.length > 0) {
      setCandidateObj(partnerFilterCandidateSelector[0]);
    }
  }, [partnerFilterCandidateSelector])

  useEffect(() => {
    if (selectedItem && partCandidateAppsSelector.length > 0) {
      const mainWorkflow = partCandidateAppsSelector.filter(x => x.workflowType === 1);
      if (mainWorkflow.length > 0 && selectedItem?.performerid > 0) {
        const wf = mainWorkflow[0];
        if (selectedItem?.performerid > 0) {
          setAppWorkflow(wf);
          dispatch(loadCandidateAppRuningTasks(wf.oldWorkflowId, selectedItem.performerid));
        }
      }
    }
  }, [partCandidateAppsSelector]);

  useEffect(() => {
    if (partCandidateAppTasksSelector.length > 0) {
      const filterTasks = partCandidateAppTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
      if (filterTasks.length > 0) {
        setWfTask(filterTasks);
        dispatch(loadReqDocuments(filterTasks[0].ciid));
      }
    }
    else {
      setWfTask(null);
    }
  }, [partCandidateAppTasksSelector]);

  useEffect(() => {
    if (reqDocumentsSelector.length > 0) {
      const reqDocs = reqDocumentsSelector.filter(x => x.sendStatus === true && x.performerId !== selectedItem?.performerid);
      setReqDocuments(reqDocs);
      if (appWorkflow && selectedItem?.performerid > 0)
        dispatch(loadAppDocuments(appWorkflow.oldWorkflowId, selectedItem.performerid));
    } else {
      setReqDocuments([]);
    }
  }, [reqDocumentsSelector]);

  useEffect(() => {
    if (appDocumentsSelector.length > 0) {
      const appDocs = appDocumentsSelector;
      setAllAppDocs(appDocs);
    } else {
      setAllAppDocs([]);
    }

  }, [appDocumentsSelector]);

  useEffect(() => {
    if (docSendStatus === "success") {
      getAlert("", "Sent Successfully", "success");
      if (selectedItem?.subcontractor?.fuid)
        dispatch(loadPartnerFilterCandidate(selectedItem?.subcontractor?.fuid, selectedItem.performerid));
    }
  }, [docSendStatus])

  const handleUploadDocShowHide = (docs) => {
    if (docs === "save") {
      setDocShowHide(false);
      setDocType("");
      if (wfTask?.[0]?.ciid > 0)
        dispatch(loadReqDocuments(wfTask?.[0]?.ciid));
    } else {
      setDocShowHide(!docShowHide);
      setDocType(docs);
    }
  };

  const getReqRefDocs = (item) => {
    if (item.refDocId > 0) {
      const findDocs = allAppDocs.filter(x => x.uploadId === item.refDocId);
      if (findDocs.length > 0) {
        return (
          <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
            {findDocs.map(doc =>
              <button
                className="btn btn-sm"
                key={doc.id || doc.documentName}
                style={{ ...CANDIDATE_WORKING_HUB_STYLES.textButton, marginRight: "8px", marginBottom: "8px" }}
                title="Download Document"
                onClick={() => handleDownloadFile(doc)
                }
              >
                <i className="fa fa-paperclip" aria-hidden="true"></i>
                {doc.documentName}
              </button>
            )}
            <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>{item.documnetName}</span>
          </td>
        )
      }
    }

    return <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>{item.documnetName}</td>

  }

  const getReqUploadedDocs = (item, type) => {
    const achDocs = allAppDocs.filter(
      (x) => x.docType === `req_${item.id}`
    );

    if (achDocs.length === 0) {
      return <>
        <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
          {item.docType?.includes('_c2c_') && (
            <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.neutralPill }}>
              Contract
            </span>
          )}
          {(item.docType !== "sharing" && !item.docType?.includes('_c2c_') && type !== "received") && (
            <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.warningPill }}>
              <i className="fa fa-clock-o" aria-hidden="true"></i> Pending
            </span>
          )}
          {type === "received" && (
            <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.successPill }}>
              <i className="fa fa-check" aria-hidden="true"></i> Received
            </span>
          )}
        </td>
        <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
          {item.docType !== "sharing" && !item.docType?.includes('_c2c_') && type !== "received" &&
            <button
              className="btn btn-sm"
              style={CANDIDATE_WORKING_HUB_STYLES.primaryButton}
              onClick={() => handleUploadDocShowHide(`req_${item.id}`)}
            >
              <i className="fa fa-upload" ></i> Upload
            </button>
          }
        </td>

      </>
    }

    if (achDocs.length > 0) {
      const doc = achDocs[achDocs.length - 1];
      return <>
        <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
          <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.successPill }}>
            <i className="fa fa-check" aria-hidden="true"></i> Uploaded
          </span>
        </td>
        <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
          <button
            className="btn btn-sm"
            style={CANDIDATE_WORKING_HUB_STYLES.textButton}
            title="Download Document"
            onClick={() => handleDownloadFile(doc)
            }
          >
            <i className="fa fa-paperclip" aria-hidden="true"></i>
            {doc.documentName}
          </button>
          {getPopover(doc.notes)}
          <button
            className="btn btn-sm"
            style={CANDIDATE_WORKING_HUB_STYLES.dangerButton}
            title="Delete File"
            onClick={() => handleDeleteFile(doc, "doc", item)}
          >
            <i className="fa fa-trash"></i> Delete
          </button>
        </td>

      </>
    }
  }

  const handleDeleteFile = async (doc, type, item) => {
    if (item.status === 1) return getAlert("", "You cannot delete approved document", "error");
    const confirm = await getConfirmAlert("", "Are you sure you want to delete this document?", "warning");
    if (confirm.isConfirmed) {
      dispatch(partnerCandidateDocDelete(doc.id, type));
    }
  };

  useEffect(() => {
    if (docDeletedStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      if (wfTask?.[0]?.ciid > 0)
        dispatch(loadReqDocuments(wfTask?.[0]?.ciid));
    }
  }, [docDeletedStatusSelector])

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <i className="fa fa-info-circle btn btn-sm" style={{ cursor: "pointer" }}></i>
      </OverlayTrigger>
    );
  };

  const getPopover1 = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button className="btn btn-sm" style={CANDIDATE_WORKING_HUB_STYLES.textButton}>
          <i className="fa fa-info-circle" aria-hidden="true"></i> View
        </button>
      </OverlayTrigger>
    );
  };

  const handleDocumentLoad = () => {
    if (wfTask?.[0]?.ciid > 0)
      dispatch(loadReqDocuments(wfTask?.[0]?.ciid));
  }

  let item = "";
  if (candidateObj)
    item = candidateObj;

  const uploadedDocCount = reqDocuments.filter((doc) =>
    allAppDocs.some((appDoc) => appDoc.docType === `req_${doc.id}`)
  ).length;
  const pendingDocCount = Math.max(reqDocuments.length - uploadedDocCount, 0);
  const sentDocCount = candidateObj?.docList?.filter((doc) => doc.sendStatus === true).length || 0;

  return (
    <React.Fragment>
      <style>{`
        .candidate-working-hub-table tbody tr:hover td {
          background-color: #f8fbff !important;
        }

        @media (max-width: 991.98px) {
          .candidate-working-hub-table {
            min-width: 980px;
          }
        }
      `}</style>
      <div className="col-md-12" style={CANDIDATE_WORKING_HUB_STYLES.pageActions}>
        <button
          className="btn btn-sm"
          style={CANDIDATE_WORKING_HUB_STYLES.backButton}
          onClick={() => navigate(-1)}
        >
          <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
        </button>
      </div>
      <div className="col-md-12 form-group">
        <div className="table-responsive" style={CANDIDATE_WORKING_HUB_STYLES.tableWrap}>
          <table className="table align-items-center table-hover mb-0 candidate-working-hub-table" style={CANDIDATE_WORKING_HUB_STYLES.summaryTable}>
            <thead>
              <tr>
                <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Candidate #<br />IPCS ID</th>
                <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Details</th>
                <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Agency</th>
                <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Duration<br />(Start-End)</th>
                <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Onboarding<br />Status</th>
              </tr>
            </thead>
            <tbody>
              {item !== "" &&
                <tr>
                  <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                    <span style={CANDIDATE_WORKING_HUB_STYLES.idPill}>{item.performerid}</span>
                    <br />
                    <span style={CANDIDATE_WORKING_HUB_STYLES.secondaryPill}>
                      IPCS ID: {item.maxloans || "N/A"}
                    </span>
                  </td>
                  <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                    <p style={CANDIDATE_WORKING_HUB_STYLES.candidateName}>
                      {item.performername} {item.lastName}
                    </p>
                    <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                      {item.performeremail || "Email not available"}
                    </span>
                    <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                      {item.contactNo ? getFormatedNumber(item.contactNo) : "Phone not available"}
                    </span>
                    <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                      {getFieldData(
                        item.performerData,
                        "projectengagement",
                        "PositionTitle"
                      ) || "Position title not available"}
                    </span>
                  </td>
                  <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                    <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                      {getFieldData(
                        item.performerData,
                        "projectengagement",
                        "AgencyName"
                      ) || "Agency not available"}
                    </span>
                  </td>
                  <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                    {item.duration !== null && (
                      <React.Fragment>
                        <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>{item.duration.duration} Months</span>
                        <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                          Start:{" "}
                          <Moment format="MMM Do YYYY">
                            {item.duration.startDate}
                          </Moment>
                        </span>
                        <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                          End:{" "}
                          <Moment format="MMM Do YYYY">
                            {item.duration.endDate}
                          </Moment>
                        </span>
                      </React.Fragment>
                    )}
                    {item.duration === null && (
                      <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>Duration not available</span>
                    )}
                  </td>
                  <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                    {item.appSubmit && (
                      <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.successPill }}>
                        <i className="fa fa-check" aria-hidden="true"></i> Complete
                      </span>
                    )}
                    {!item.appSubmit && (
                      <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.warningPill }}>
                        <i className="fa fa-clock-o" aria-hidden="true"></i> Pending
                      </span>
                    )}
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-md-12">
        <div className="card shadow-none" style={CANDIDATE_WORKING_HUB_STYLES.card}>
          <div className="card-header" style={CANDIDATE_WORKING_HUB_STYLES.cardHeader}>
            <div style={CANDIDATE_WORKING_HUB_STYLES.headerRow}>
              <div style={CANDIDATE_WORKING_HUB_STYLES.titleWrap}>
                <span style={CANDIDATE_WORKING_HUB_STYLES.titleIcon}>
                  <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                </span>
                <div>
                  <h2 style={CANDIDATE_WORKING_HUB_STYLES.title}>Candidate Working Hub</h2>
                  <p style={CANDIDATE_WORKING_HUB_STYLES.subtitle}>
                    Upload required documents, review shared files, and send completed items into the workflow.
                  </p>
                </div>
              </div>
              <div style={CANDIDATE_WORKING_HUB_STYLES.headerActions}>
                <button
                  className="btn btn-sm"
                  style={CANDIDATE_WORKING_HUB_STYLES.primaryButton}
                  onClick={handleDocumentLoad}
                >
                  <i className="fa fa-refresh" aria-hidden="true"></i> Refresh
                </button>
              </div>
            </div>
          </div>
          <div className="card-body" style={CANDIDATE_WORKING_HUB_STYLES.cardBody}>
            <div style={CANDIDATE_WORKING_HUB_STYLES.statsRow}>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statCard}>
                <p style={CANDIDATE_WORKING_HUB_STYLES.statLabel}>Required</p>
                <p style={CANDIDATE_WORKING_HUB_STYLES.statValue}>{reqDocuments.length}</p>
              </div>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statCard}>
                <p style={CANDIDATE_WORKING_HUB_STYLES.statLabel}>Uploaded</p>
                <p style={CANDIDATE_WORKING_HUB_STYLES.statValue}>{uploadedDocCount}</p>
              </div>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statCard}>
                <p style={CANDIDATE_WORKING_HUB_STYLES.statLabel}>Pending</p>
                <p style={CANDIDATE_WORKING_HUB_STYLES.statValue}>{pendingDocCount}</p>
              </div>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statCard}>
                <p style={CANDIDATE_WORKING_HUB_STYLES.statLabel}>Sent</p>
                <p style={CANDIDATE_WORKING_HUB_STYLES.statValue}>{sentDocCount}</p>
              </div>
            </div>

            <div className="table-responsive" style={CANDIDATE_WORKING_HUB_STYLES.tableWrap}>
              <table className="table align-items-center table-hover mb-0 candidate-working-hub-table" style={CANDIDATE_WORKING_HUB_STYLES.table}>
                <thead>
                  <tr>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}></th>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Date & Time</th>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Requirement</th>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Notes</th>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Status</th>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {reqDocuments.map((item, key) =>
                    <tr key={item.id || key}>
                      <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                        <span style={CANDIDATE_WORKING_HUB_STYLES.idPill}>{key + 1}</span>
                      </td>
                      <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                        <Moment format="MMM Do YYYY, h:mm a">
                          {item.addedDateTime}
                        </Moment>
                      </td>
                      {getReqRefDocs(item)}
                      <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>{getPopover1(item.notes)}</td>
                      {getReqUploadedDocs(item, "req")}
                    </tr>
                  )}
                  {reqDocuments.length === 0 && (
                    <tr>
                      <td colSpan={6} className="p-0 border-0">
                        <div style={CANDIDATE_WORKING_HUB_STYLES.emptyState}>
                          No document requirements are available for this candidate yet.
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {docShowHide &&
        <UploadDocPopup
          uploadDocShowHide={docShowHide}
          handleUploadDocModalShowHide={handleUploadDocShowHide}
          runningApplication={wfTask}
          selectedDocType={docType}
          contactDoc={docType === "" ? "Your document has been successfully attached to workbench portal" : "Your required document has been successfully attached to workbench portal"}
        ></UploadDocPopup>}
    </React.Fragment>
  );
}
